// extracted by mini-css-extract-plugin
export default {"wingContainer":"WingSettings_wingContainer__OmeoI","wingWrapper":"WingSettings_wingWrapper__5AiG4"};